"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleMusic = void 0;
const react_1 = __importDefault(require("react"));
const AppleMusic = ({ url }) => (react_1.default.createElement("iframe", { allow: "autoplay *; encrypted-media *; fullscreen *; clipboard-write", frameBorder: "0", height: "175", style: { borderRadius: '10px', overflow: 'hidden', width: '100%' }, sandbox: "allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation", src: url }));
exports.AppleMusic = AppleMusic;
